// Frontend mirror of backend vapt/target_validation.py::validate_target_value.
// The backend is authoritative; this exists only so the user gets immediate
// feedback. Keep the two rule sets in sync.

const HOST_LABEL = "[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?";
const DOMAIN_RE = new RegExp(`^(?:${HOST_LABEL}\\.)+[A-Za-z]{2,}$`);
const HOSTNAME_RE = new RegExp(`^(?:${HOST_LABEL}\\.)*${HOST_LABEL}$`);
const MAX_LEN = 500;

const isIPv4 = (s) => {
  const m = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/.exec(s);
  return !!m && m.slice(1).every((o) => Number(o) <= 255);
};
const isIPv6 = (s) => s.includes(":") && /^[0-9A-Fa-f:.]+$/.test(s) && s.split(":").length >= 3;
const isIp = (s) => isIPv4(s) || isIPv6(s);
const validWebHost = (host) => !!host && (isIp(host) || host.toLowerCase() === "localhost" || DOMAIN_RE.test(host));

const parseWeb = (v) => {
  try {
    const url = new URL(v.includes("://") ? v : `https://${v}`);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    return url.hostname.replace(/^\[|\]$/g, "");
  } catch {
    return null;
  }
};

const hasWhitespaceOrControl = (s) =>
  /\s/.test(s) || Array.from(s).some((ch) => ch.charCodeAt(0) < 32 || ch.charCodeAt(0) === 127);

export const validateTargetForDomain = (value, domain) => {
  const v = (value || "").trim();
  if (!v) return "Target cannot be empty.";
  if (v.length > MAX_LEN) return `Target is too long (maximum ${MAX_LEN} characters).`;
  if (hasWhitespaceOrControl(v)) {
    return `"${v}" is not a valid target: it must not contain spaces or control characters.`;
  }
  if (domain === "Web" || domain === "API") {
    if (!validWebHost(parseWeb(v))) {
      return `"${v}" doesn't look like a valid ${domain === "Web" ? "URL/domain" : "API URL/hostname"}.`;
    }
  } else if (domain === "Infrastructure") {
    const [base, prefix] = v.split("/", 2);
    if (isIp(base)) {
      if (prefix !== undefined) {
        const max = isIPv4(base) ? 32 : 128;
        if (!/^\d{1,3}$/.test(prefix) || Number(prefix) > max) return `"${v}" is not a valid IP/CIDR.`;
      }
    } else if (prefix !== undefined || !HOSTNAME_RE.test(v) || /^[\d.]+$/.test(v)) {
      return `"${v}" doesn't look like a valid IP/CIDR/hostname.`;
    }
  } else if (domain === "Mobile" && !/\.(apk|ipa)$/i.test(v)) {
    return `"${v}" doesn't look like a mobile app file (.apk/.ipa).`;
  }
  return null;
};
